import {
  FETCH_LEAVE_ALLOCATION_REQUEST, FETCH_LEAVE_ALLOCATION_SUCCESS, FETCH_LEAVE_ALLOCATION_FAIL,
  CLEAR_LEAVE_ALLOCATION,
  FETCH_LEAVE_SUMMARY_REQUEST, FETCH_LEAVE_SUMMARY_SUCCESS, FETCH_LEAVE_SUMMARY_FAIL,
} from "../../constants/Leave/LeaveAllocationConstants";
import LeaveAllocationService from "../../service/Leave/LeaveAllocationService";
import { extractRows, assertOk } from "../../service/Leave/leaveHelpers";

const errMsg = (error, fallback) => error.response?.data?.Result || error.response?.data?.message || error.message || fallback;
const n = (v) => Number(v) || 0;
const s = (v) => String(v ?? "").trim();

const mapAllocation = (item, idx) => ({
  key: `${s(item.HLA_ALLOCATION_ID ?? item.HLA_LEAVE_TYPE_ID) || "row"}-${s(item.HLA_LEAVE_YEAR)}-${idx}`,
  typeId: s(item.HLA_LEAVE_TYPE_ID ?? item.HLT_TYPE_ID),
  typeCode: s(item.HLT_CODE ?? item.HLA_LEAVE_TYPE_CODE).toUpperCase(),
  typeName: s(item.HLT_NAME ?? item.HLA_LEAVE_TYPE_NAME),
  year: s(item.HLA_LEAVE_YEAR),
  allocated: n(item.HLA_ALLOCATED_DAYS),
  adjustment: n(item.HLA_ADJUSTMENT_DAYS),
  earned: n(item.HLA_EARNED_DAYS),
  used: n(item.HLA_USED_DAYS),
  balance: n(item.HLA_BALANCE_DAYS),
});

const mapSummary = (item, idx) => ({
  key: `${s(item.HLA_EMP_SERVICE_NO)}-${s(item.LEAVE_TYPE_CODE)}-${s(item.HLA_LEAVE_YEAR)}-${idx}`,
  serviceNo: s(item.HLA_EMP_SERVICE_NO),
  employeeName: s(item.EMPLOYEE_NAME),
  typeId: s(item.HLA_LEAVE_TYPE_ID),
  typeCode: s(item.LEAVE_TYPE_CODE).toUpperCase(),
  typeName: s(item.LEAVE_TYPE_NAME),
  year: s(item.HLA_LEAVE_YEAR),
  allocated: n(item.TOTAL_ALLOCATED_DAYS),
  adjustment: n(item.TOTAL_ADJUSTMENT_DAYS),
  earned: n(item.TOTAL_EARNED_DAYS),
  used: n(item.TOTAL_USED_DAYS),
  balance: n(item.TOTAL_BALANCE_DAYS),
});

export const fetchLeaveAllocation = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LEAVE_ALLOCATION_REQUEST });
    const body = assertOk(await LeaveAllocationService.getByEmployee(serviceNo));
    dispatch({ type: FETCH_LEAVE_ALLOCATION_SUCCESS, payload: extractRows(body).map(mapAllocation) });
  } catch (error) {
    dispatch({ type: FETCH_LEAVE_ALLOCATION_FAIL, payload: errMsg(error, "Failed to fetch leave allocation") });
  }
};

export const clearLeaveAllocation = () => ({ type: CLEAR_LEAVE_ALLOCATION });

export const fetchLeaveSummary = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LEAVE_SUMMARY_REQUEST });
    const body = assertOk(await LeaveAllocationService.getSummary());
    dispatch({ type: FETCH_LEAVE_SUMMARY_SUCCESS, payload: extractRows(body).map(mapSummary) });
  } catch (error) {
    dispatch({ type: FETCH_LEAVE_SUMMARY_FAIL, payload: errMsg(error, "Failed to fetch leave balances") });
  }
};